import {
  USER_LIST_UPDATE_GAMEPLAYER_BASIC_PROFILE,
  USER_LIST_UPDATE_GAMEPLAYER_COMMON_TOPICS,
  USER_LIST_UPDATE_GAMEPLAYER_EXPIRES_AT,
  CLEAR_USER_LIST_STATE,
  UPDATE_USER_LIST_STATE,
  UPDATE_REQUEST_USER_FOLLOWER_LIST_STATE,
} from "./types";

export function updateBasicProfile(payload) {
  return {
    type: USER_LIST_UPDATE_GAMEPLAYER_BASIC_PROFILE,
    payload,
  };
}

export function updateUserCommonTopicsWithDisplayUser(payload) {
  return {
    type: USER_LIST_UPDATE_GAMEPLAYER_COMMON_TOPICS,
    payload,
  };
}

export function updateExpires(payload) {
  return {
    type: USER_LIST_UPDATE_GAMEPLAYER_EXPIRES_AT,
    payload,
  };
}

export function clearUserListState() {
  return {
    type: CLEAR_USER_LIST_STATE,
  };
}

export function updateUserListState(payload) {
  return {
    type: UPDATE_USER_LIST_STATE,
    payload,
  };
}

export function updateRequestFollowerListState(payload) {
  return {
    type: UPDATE_REQUEST_USER_FOLLOWER_LIST_STATE,
    payload,
  };
}
